(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-marquee"] && !Shopify.designMode) return;
  try {
    
(function() {
  if (window.__announcementRotateInit) return;
  window.__announcementRotateInit = true;
  function init() {
    document.querySelectorAll('[data-announcement-rotate]').forEach(function(root) {
      var items = root.querySelectorAll('.announcement-marquee__item--rotate');
      if (items.length <= 1) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var interval = parseInt(root.dataset.interval || '4000', 10);
      var current = 0;
      setInterval(function() {
        items[current].classList.remove('is-active');
        current = (current + 1) % items.length;
        items[current].classList.add('is-active');
      }, interval);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product-spotlight"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__featuredSpotlightInit) return;
  window.__featuredSpotlightInit = true;
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.classList || !form.classList.contains('featured-spotlight__form')) return;
    var btn = form.querySelector('[data-spotlight-add]');
    if (!btn) return;
    e.preventDefault();
    var addUrl = btn.dataset.cartAddUrl || '/cart/add';
    var cartUrl = btn.dataset.cartUrl || '/cart';
    var productUrl = btn.dataset.productUrl;
    var originalLabel = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';
    fetch(addUrl + '.js', { method: 'POST', headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' }, body: new FormData(form) })
      .then(function (res) { if (!res.ok) throw new Error('add failed'); return res.json(); })
      .then(function () { return fetch(cartUrl + '?sections=cart-notification,cart-drawer,cart-icon-bubble'); })
      .then(function (res) { return res ? res.json() : null; })
      .then(function (sections) {
        if (sections) {
          Object.keys(sections).forEach(function (name) {
            var html = sections[name]; if (!html) return;
            var parsed = new DOMParser().parseFromString(html, 'text/html');
            var newEl = parsed.querySelector('#shopify-section-' + name) || parsed.querySelector('[id^="shopify-section-' + name + '"]');
            var target = document.querySelector('#shopify-section-' + name) || document.querySelector('[id^="shopify-section-' + name + '"]');
            if (newEl && target) target.innerHTML = newEl.innerHTML;
          });
        }
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.open === 'function') { drawer.open(); }
        else { var notif = document.querySelector('cart-notification'); if (notif && typeof notif.open === 'function') notif.open(); }
        document.dispatchEvent(new CustomEvent('cart:updated'));
      })
      .catch(function () { if (productUrl) window.location.href = productUrl; })
      .finally(function () { btn.disabled = false; btn.textContent = originalLabel; });
  }, false);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["review-marquee"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__reviewSlideshowInit) return;
  window.__reviewSlideshowInit = true;
  function init(rs) {
    var track = rs.querySelector('[data-rs-track]');
    if (!track) return;
    var prev = rs.querySelector('[data-rs-prev]');
    var next = rs.querySelector('[data-rs-next]');
    function cardStep() {
      var card = track.querySelector('.review-card');
      if (!card) return track.clientWidth;
      var s = getComputedStyle(track);
      return card.offsetWidth + (parseFloat(s.columnGap || s.gap) || 0);
    }
    function go(dir) {
      var max = track.scrollWidth - track.clientWidth - 2;
      if (dir > 0 && track.scrollLeft >= max) { track.scrollTo({ left: 0, behavior: 'smooth' }); return; }
      if (dir < 0 && track.scrollLeft <= 2) { track.scrollTo({ left: max, behavior: 'smooth' }); return; }
      track.scrollBy({ left: dir * cardStep(), behavior: 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
    var ms = parseInt(rs.getAttribute('data-rs-autoplay'), 10);
    if (ms && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var timer = setInterval(function () { go(1); }, ms);
      rs.addEventListener('mouseenter', function () { clearInterval(timer); });
    }
  }
  document.querySelectorAll('[data-rs]').forEach(init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["usp-marquee"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__uspMarqueeInit) return;
  window.__uspMarqueeInit = true;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.querySelectorAll('.usp-marquee').forEach(function (root) {
    var toggle = root.querySelector('[data-usp-toggle]');
    var continuousMarquee = root.querySelector('[data-usp-continuous]');
    if (toggle && continuousMarquee) {
      var paused = false;
      toggle.addEventListener('click', function () {
        paused = !paused;
        if (paused) {
          root.setAttribute('data-usp-stopped', '');
          toggle.setAttribute('aria-pressed', 'false');
          toggle.setAttribute('aria-label', 'Play');
          toggle.textContent = '▶';
        } else {
          root.removeAttribute('data-usp-stopped');
          toggle.setAttribute('aria-pressed', 'true');
          toggle.setAttribute('aria-label', 'Pause');
          toggle.textContent = '‖';
        }
      });
    }
    var paged = root.querySelector('[data-usp-paged]');
    if (!paged) return;
    var track = paged.querySelector('[data-usp-paged-track]');
    var items = paged.querySelectorAll('[data-usp-item]');
    if (!track || items.length === 0) return;
    var counter = paged.querySelector('[data-usp-counter]');
    var prevBtn = paged.querySelector('[data-usp-prev]');
    var nextBtn = paged.querySelector('[data-usp-next]');
    var pageToggle = paged.querySelector('[data-usp-toggle]');
    var autoplayMs = parseInt(paged.dataset.autoplay || '4000', 10);
    function getPerView() {
      var isMobile = window.matchMedia('(max-width: 749px)').matches;
      return parseInt(isMobile ? paged.dataset.perViewMobile : paged.dataset.perViewDesktop, 10) || 1;
    }
    var current = 0;
    var totalPages = 1;
    var timer = null;
    var playing = !reduceMotion;
    function layout() {
      var perView = getPerView();
      paged.style.setProperty('--usp-per-view', perView);
      totalPages = Math.max(1, Math.ceil(items.length / perView));
      if (current >= totalPages) current = 0;
      render();
    }
    function render() {
      track.style.transform = 'translateX(-' + (current * 100) + '%)';
      if (counter) counter.textContent = (current + 1) + '/' + totalPages;
    }
    function next() { current = (current + 1) % totalPages; render(); }
    function prev() { current = (current - 1 + totalPages) % totalPages; render(); }
    function start() {
      stop();
      if (!playing) return;
      timer = setInterval(next, autoplayMs);
      if (pageToggle) {
        pageToggle.setAttribute('aria-pressed', 'true');
        pageToggle.setAttribute('aria-label', 'Pause');
        pageToggle.textContent = '‖';
      }
    }
    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
      if (pageToggle) {
        pageToggle.setAttribute('aria-pressed', 'false');
        pageToggle.setAttribute('aria-label', 'Play');
        pageToggle.textContent = '▶';
      }
    }
    if (prevBtn) prevBtn.addEventListener('click', function () { prev(); if (playing) start(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { next(); if (playing) start(); });
    if (pageToggle) pageToggle.addEventListener('click', function () { playing = !playing; if (playing) start(); else stop(); });
    window.addEventListener('resize', function () { layout(); });
    layout();
    if (playing) start();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
